import {
	Box,
	Button,
	Checkbox,
	Table,
	TablePagination,
	TBody,
	TCell,
	THead,
	TRow,
	Typography
} from "@launchmetrics/lm-ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";

import { ReactComponent as CreateReportsIcon} from 'vendor/svg/report/create_report.svg';
import { ReactComponent as ArrowDownIcon} from 'vendor/svg/report/arrow_down.svg';
import { useSelector } from "react-redux";
import { RootState } from "store";
import reportConfigurationSelectors from "store/models/reportConfiguration/selectors";
import { ModelType as ReportConfigurationModel}  from 'store/models/reportConfiguration/reducers';

const ROWS_PER_PAGE_OPTIONS = [1, 5, 10, 20, 50, 100];


export const ReportManager = () => {
	const [page, setPage] = React.useState(1);
	const [pageSize, setPageSize] = React.useState(ROWS_PER_PAGE_OPTIONS[2]);
	const reportConfiguration = useSelector((state: RootState) => reportConfigurationSelectors.getAllReports(state)).items;
	const totalReports = reportConfiguration.length;

	const styles = useStyles();
	const { t } = useTranslation();

	const handlePageChange = React.useCallback((value: number) => setPage(value), []);
	const handleRowPerPageChange = React.useCallback((value: number) => setPageSize(value), []);

	return (
		<Box id={"report-manager"} styleProps={styles.reportManager}>
			<Box styleProps={styles.reportManagerMainHeader}>
				<Typography variant={"headingSmBold"}>{t('reports.manager.title')}</Typography>
				<Button leftIcon={<CreateReportsIcon />} rightIcon={<ArrowDownIcon />}>{t('reports_manager.article.dropdown.label')}</Button>
			</Box>
			<Box styleProps={styles.reportManagerPaginationContainer}>
				<TablePagination
					page={page}
					rowsPerPage={pageSize}
					onPageChange={handlePageChange}
					onRowsPerPageChange={handleRowPerPageChange}
					count={totalReports}
					rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
					id={'tablePagination'}
				/>
			</Box>
			<Box styleProps={styles.reportManagerTableContainer}>
				<Typography styleProps={styles.totalReports}>{t('reports.manager.total_reports')}: {totalReports}
				</Typography>
				<Table id={"reportManagerTable"}>
					<THead>
						<TRow>
							<TCell>
								<Checkbox
									checked={false}
									size="medium"
									indeterminate={false}
									onChange={() => {}}
								/>
							</TCell>
							<TCell styleProps={styles.tableHeaders}>{t('reports.manager.table.name')}</TCell>
							<TCell styleProps={styles.tableHeaders}>{t('reports.manager.table.format')}</TCell>
							<TCell styleProps={styles.tableHeaders}>{t('reports.manager.table.creation_date')}</TCell>
							<TCell styleProps={styles.tableHeaders}>{t('reports.manager.table.date_period')}</TCell>
							<TCell styleProps={styles.tableHeaders}>{t('reports.manager.table.actions')}</TCell>
						</TRow>
					</THead>
					<TBody>
						{reportConfiguration && reportConfiguration.slice((page - 1) * pageSize, page * pageSize).map((report: ReportConfigurationModel) => {
							return (
								<TRow id={`report-manager-table-row-${report.id}`} key={report.id}>
									<TCell>
										<Checkbox
											checked={false}
											size="medium"
											indeterminate={false}
											onChange={() => {}}
										/>
									</TCell>
									<TCell>{report.name}</TCell>
									<TCell>{report.type}</TCell>
									<TCell>{report.inserted_at}</TCell>
									<TCell> - </TCell>
									<TCell> - </TCell>
								</TRow>
							);
						})}
					</TBody>
				</Table>
			</Box>
		</Box>
	);
};
